<template>
  <div>
    <BaseDialog
        title="表示項目保存"
        :visible.sync="dialogVisible"
        width="700px"
        :append-to-body="true"
        :show-only-close-button="false"
        @ok="save"
        @cancel="close">
      <template slot="contents">
        <!-- 表示項目 -->
        <div class="dialog-inner">
          <BaseTableDetail
              :editable="editable"
              :table-set-list="tableSetList"
              :display-item="tableData" />
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>

.dialog-inner ::v-deep table {
  width: 100%
}
.dialog-inner ::v-deep table th {
  text-align-last: left;
  width: 70px;
}

</style>
<script>

import BaseDialog from '@/components/molecules/BaseDialog'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import message from '@/utils/message'
import * as define from '@/define'
import common from '@/utils/common'
import * as config from '@/config'

const EDITABLE = Object.freeze({
  name: true,
  isPublic: true
})

export default {
  name: 'BaseDisplaySelectModal',
  components: {
    BaseDialog,
    BaseTableDetail
  },
  inject: ['parentValidator'],
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    displayConfig: {
      type: Array,
      required: true,
      default: () => []
    },
    functionKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogDisplayConfig: [],
      tableData: {
        name: '',
        isPublic: 0
      }
    }
  },
  computed: {
    editable () {
      return EDITABLE
    },
    tableSetList () {
      return [
        {
          label: '名前',
          properties: [
            {
              path: 'name', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', validateAs: '名前', editableId: 'name'
            }
          ]
        },
        {
          label: '公開',
          properties: [
            {
              path: 'isPublic', type: 'Number', editableId: 'isPublic',
              elementType: ELEMENT_TYPE.RADIO_BUTTON,
              selectCode: () => {
                return [
                  { code: 0, name: '個人' },
                  { code: 1, name: '公開' }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (this.dialogVisible) {
        // 初期化
        this.tableData = {
          name: '',
          isPublic: 0
        }
      }
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    close () {
      this.dialogVisible = false
    },
    async save () {
      if (!await this.$validator.validate()) {
        return
      }

      this.$confirm('表示項目を保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // APIコール
          const url = config.DISPLAY_ITEM
          const method = 'post'

          const displayItems = this.displayConfig.filter((data) => data.isDisplay)
            .map((data) => {
              return {
                uuid: data.uuid
              }
            })

          const data = {
            name: this.tableData.name,
            functionKey: this.functionKey,
            isPublic: this.tableData.isPublic,
            displayItems
          }
          await common.apiAxios(url, { method, data })

          this.$notify.success('保存しました。')
          // ダイアログを閉じる
          this.close()
        } catch (error) {
          common.addError(error, { msg: message.MSG_502() })
          this.$notify.error({ error: error })
        } finally {
          this.$loadingService.close()
        }
      }).catch((error) => {
        if (error === 'cancel') this.$notify.info('キャンセルしました。')
      })
    }
  }
}
</script>
